
import Vue from "vue";
import * as types from "@/store/mutation-types";
import { FormBlock } from "@/components/FormBuilder/types";
import { objectDifference } from "@/helpers";
import { roofStructureFormSchema } from "@/forms/admin/roofStructure";
import {
  roofStructureMapActions,
  roofStructureMapGetters,
  roofStructureMapMutations,
  roofStructureMapState
} from "@/store/modules/roofStructure";

export default Vue.extend({
  name: "UpdateRoofStructureView",
  data() {
    return {
      resourceNotFound: false,
      errorMessage: "",
      isLoading: false,
      successMessage: "",
      loadingText: ""
    };
  },
  created() {
    this.getRoofStructure(this.roofStructureId)
      .then(data => {
        this.SET_EDIT(data);
      })
      .catch(error => {
        this.resourceNotFound = true;
        this.$bugSnagClient.notify(error);
      });
  },
  destroyed() {
    this.SET_EDIT(" " as any);
  },
  methods: {
    ...roofStructureMapActions(["getRoofStructure", "updateRoofStructure"]),
    ...roofStructureMapMutations(["SET_EDIT"]),
    ...roofStructureMapMutations({ editField: types.SET_EDIT_FIELD }),
    formFieldChangeHandler({ key, value }: { key: any; value: any }) {
      this.editField({ key, value });
    },
    onToolbarItemClick(event: string) {
      switch (event) {
        case "cancelEditRoofStructure":
          this.roofStructuresCallback();
          break;
        case "update":
          this.updateCallback();
          break;
      }
    },
    async roofStructuresCallback(): Promise<any> {
      this.$router.push("/admin/roofStructures").catch(() => {});
    },
    async updateCallback(): Promise<void> {
      try {
        this.isLoading = true;
        this.loadingText = "Updating roof structure. Please wait...";
        await this.updateRoofStructure({
          id: this.roofStructureId,
          update: this.updatedFields
        });
        this.$appNotifySuccess("Roof Structure Updated Successfully");
        this.roofStructuresCallback();
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    }
  },
  computed: {
    ...roofStructureMapGetters([
      "getRoofStructureById",
      "editingRoofStructure"
    ]),
    ...roofStructureMapState(["makingApiRequest", "editing"]),
    roofStructureId(): string {
      return this.$route.params.roofStructureId;
    },
    roofStructure(): any {
      return this.getRoofStructureById(this.roofStructureId);
    },
    updatedFields(): any {
      const edited = this.editingRoofStructure;
      const original = this.roofStructure;
      return edited && original ? objectDifference(edited, original) : {};
    },
    roofStructureFields(): FormBlock[] {
      return roofStructureFormSchema;
    }
  }
});
